//ARCGIS Start
import webMap from '@arcgis/core/WebMap';
import MapView from '@arcgis/core/views/MapView';
import Basemap from "@arcgis/core/Basemap";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import Extent from "@arcgis/core/geometry/Extent";

import esriConfig from "@arcgis/core/config";
import * as urlUtils from "@arcgis/core/core/urlUtils";


//import esriConfig from "@arcgis/core/config";

// import { AppData } from '../settings.js';

let time;
let KACode = "";
let AppData;

export async function initializeMap(options, enableProxy = false, config) {
    debugger
    // var host = 'https://webgis.momra.gov.sa';
    // var url = 'https://webgis.momra.gov.sa/hosted/rest/services/Hosted/BaseMap_FinalCart/VectorTileServer?f=pjson';
    // var access_token = "I&AM&A&TOKEN&&&&&";
    AppData = config;

    if (enableProxy) {
        //#region start configer proxy on Map
        urlUtils.addProxyRule({
            urlPrefix: AppData.proxy.urlPrefix,
            proxyUrl: AppData.proxy.proxyURL
        });

        // urlUtils.addProxyRule({
        //     urlPrefix: AppData.proxy.urlLayerPrefix,
        //     proxyUrl: AppData.proxy.proxyURL
        // });


        // urlUtils.addProxyRule({
        //     urlPrefix: AppData.proxy.urlCitiesPrefix,
        //     proxyUrl: AppData.proxy.proxyURL
        // });

        // urlUtils.addProxyRule({
        //     urlPrefix: AppData.proxy.urlstreetVendorPrefix,
        //     proxyUrl: AppData.proxy.proxyURL
        // });

        esriConfig.request.proxyUrl = AppData.proxy.proxyURL;
        esriConfig.request.forceProxy = true;
        //#endregion
        debugger
        // esriConfig.request.interceptors.push({
        //     urls: host,
        //     before: function(params) {
        //       if (params.url.includes(url)) {
        //         params.requestOptions.headers = params.requestOptions.headers || {};
        //         params.requestOptions.headers.ACCESS_TOKEN = access_token;
        //       }
        //     }
        // })
        esriConfig.request.interceptors.push({
            urls: [
                AppData.streetVendor, 
                AppData.Cites,
                AppData.proxy.urlPrefix,
                
                // AppData.proxy.urlLayerPrefix,
                // AppData.proxy.urlstreetVendorPrefix
            ],
            headers: {
                'KACode': ''
            },
            before: injectHCode
        });
    }



    let basemap = new Basemap({
        baseLayers: [
            new VectorTileLayer({
                url: options.vectorTileURL
            })
        ],
        title: "streetVendorsBasemap",
        id: "streetVendorsBasemap"
    });

    const map = new webMap({
        basemap: basemap
    });

    const view = new MapView({
        container: options.mapDivId,
        extent: new Extent({
            xmax: 65.94007328639653,
            xmin: 23.75248891122779,
            ymax: 33.42665681913392,
            ymin: 14.552107351284993,
        }),
        map: map,
        constraints: {
            minScale: 18489334.715908278
        },

        background: { // autocasts new ColorBackground()
            color: "whitesmoke" // autocasts as new Color()
        }
    })

    view.when(() => {
        AppData.mapView = view
        view.ui.remove("attribution");
        view.ui.move(["zoom"], "top-left");
    },
        error => {
            console.log(error);
        })
    return view;
}

export function mapViewObject(mapView) {
    return mapView;
};

export async function getHCode() {
    let url = AppData.apiendpoint.KaCode;
    var hCode = fetch(`${AppData.ApiDomainCadfileURL}/${url}`, {
        method: "POST"
    })
        .then(response => response.json());
    return hCode;
}

async function injectHCode(parameter) {
    let acutalTime = new Date();
    if (acutalTime.getMinutes() >= 56 || KACode == "") {
        KACode = await getHCode();
        AppData.KACode = KACode;
        parameter.requestOptions.headers.KACode = KACode;
    }
    else {
        parameter.requestOptions.headers.KACode = KACode;
    }
}